import styled, { withTheme } from 'styled-components'

const ContainerDivider = styled.div`
  position: relative;
  margin-left: 0;
  border-bottom: 1px ${(props) => props.theme.colors.grey_light_op30} solid;
  z-index: 4;
  background: ${(props) => props.theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  a {
    color: ${(props) => props.theme.colors.grey};
    text-decoration: none;
  }
`

export default withTheme(ContainerDivider)
